import types from './types';

const getPersonAutocompleteListAction = (name, isNotMissingCompetencies, showPersonalData, includeNotAtCern = false, isHse = false) => ({
  type: types.GET_PERSON_AUTOCOMPLETE_LIST,
  params: { name, isNotMissingCompetencies, showPersonalData, includeNotAtCern, isHse }
});

export default {
  getPersonAutocompleteListAction
};
